import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/_services';
import { DataService } from '../../../_helpers/index';

@Component({
  selector: 'app-snav-menu-controller',
  template: `
    <ng-container *ngIf="designVersion === 'V1'">
      <app-old-snav-menu [version]="version"></app-old-snav-menu>
    </ng-container>

    <ng-container *ngIf="designVersion === 'V2'">
      <app-new-snav-menu [version]="version"></app-new-snav-menu>
    </ng-container>
  `,
})
export class SnavMenuController implements OnInit, OnDestroy { 

  version: string = '1.2.33.18';
  customerPuplic_key: string;
  importationConfiguration$: Subscription;
  designVersion: 'V1' | 'V2' | '' = '';
  private destroy$ = new Subject<void>();

  constructor(
    private configurationService: ConfigurationService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.getCustomerDesignConfiguration();
  }

  getCustomerDesignConfiguration() {
    this.dataService.designVersion$
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe(designVersion => this.designVersion = designVersion);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
